import client from '../client';

export const getAllMenus = async (params = {}) => {
  const { page = 1, limit = 10, searchName = '', category = '' } = params;

  const queryParams = { page, limit };
  if (searchName) queryParams.searchName = searchName;
  if (category) queryParams.category = category;

  try {
    const res = await client.get('/salon/menus', { params: queryParams });
    const body = res.data;

    return {
      success: true,
      data: body.result ?? null,
    };
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message ?? 'メニュー取得に失敗しました',
      code: error?.response?.status ?? 500,
      data: { salonMenus: [], pagination: { currentPage: page, totalPages: 0, totalItems: 0, itemsPerPage: limit } },
    };
  }
};

export const getMenuById = async (menuId) => {
  try {
    const res = await client.get('/salon/menu', { params: { menuId } });
    const body = res.data;

    return {
      success: true,
      data: body?.result ?? null,
    };
  } catch (error) {
    return {
      success: false,
      message: 'メニューの取得に失敗しました',
      code: error?.response?.status ?? 500,
      data: null,
    };
  }
};

export const createMenu = async (menuData) => {
  try {
    const res = await client.post('/salon/menu/create', menuData);
    const body = res.data;

    return {
      success: body?.success ?? true,
      data: body?.result ?? null,
      message: body?.message ?? 'メニューの作成に失敗しました',
    };
  } catch (error) {
    return {
      success: false,
      message: 'メニューの作成に失敗しました',
      code: error?.response?.status ?? 500,
      data: null,
    };
  }
};

export const updateMenu = async (menuId, menuData) => {
  try {
    const res = await client.put('/salon/menu/update', menuData, { params: { id: menuId } });
    const body = res.data;

    return {
      success: body?.success ?? true,
      data: body?.result ?? null,
      message: body?.message ?? 'メニューの更新に失敗しました',
    };
  } catch (error) {
    return {
      success: false,
      message: 'メニューの更新に失敗しました',
      code: error?.response?.status ?? 500,
      data: null,
    };
  }
};

export const deleteMenu = async (menuId) => {
  try {
    const res = await client.delete('/salon/menu/delete', { params: { id: menuId } });
    const body = res.data;

    return {
      success: body?.success ?? true,
      message: body?.message ?? 'メニューの削除に失敗しました',
    };
  } catch (error) {
    return {
      success: false,
      message: 'メニューの削除に失敗しました',
      code: error?.response?.status ?? 500,
    };
  }
};

export default { getAllMenus, getMenuById, createMenu, updateMenu, deleteMenu };
